import { render, staticRenderFns } from "./mobot.vue?vue&type=template&id=04c5ceb2"
import script from "./mobot.vue?vue&type=script&lang=js"
export * from "./mobot.vue?vue&type=script&lang=js"
import style0 from "./mobot.vue?vue&type=style&index=0&id=04c5ceb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports